import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

/**
 * 环境变量校验（@t3-oss/env-nextjs + zod）
 * 新增变量时在此声明，并在 runtimeEnv 中映射
 */
export const env = createEnv({
	server: {
		NODE_ENV: z.enum(["development", "test", "production"]).optional(),
		NEWS_CENTER_INNER: z.string(),
		USER_CENTER_INNER: z.string(),
		SPOT_CENTER_INNER: z.string(),
	},
	client: {
		NEXT_PUBLIC_ENV: z.enum(["development", "test", "production"]),
		NEXT_PUBLIC_NAME: z.string(),
		NEXT_PUBLIC_API_HOST_EN: z.string().url(),
		NEXT_PUBLIC_AUTH_TOKEN_KEY: z.string(),
		NEXT_PUBLIC_DEPLOY_CDN: z.string(),
		NEXT_PUBLIC_DEPLOY_HOST: z.url(),
		NEXT_PUBLIC_DEPLOY_SUFFIX: z.string(),
		NEXT_PUBLIC_DEPLOY_APP_NAME: z.string(),
		NEXT_PUBLIC_DEPLOY_VERSION: z.string(),
		NEXT_PUBLIC_SENTRY_DSN: z
			.string()
			.transform((s) => (s === "" ? undefined : s))
			.pipe(z.string().url().optional()),
		NEXT_PUBLIC_SENTRY_ENABLED: z
			.string()
			.transform((val) => val === "true")
			.optional()
			.default(false),
	},
	runtimeEnv: {
		NODE_ENV: process.env.NODE_ENV,
		NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
		NEXT_PUBLIC_NAME: process.env.NEXT_PUBLIC_NAME,
		NEXT_PUBLIC_AUTH_TOKEN_KEY: process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY,
		NEWS_CENTER_INNER: process.env.NEWS_CENTER_INNER,
		USER_CENTER_INNER: process.env.USER_CENTER_INNER,
		SPOT_CENTER_INNER: process.env.SPOT_CENTER_INNER,
		NEXT_PUBLIC_API_HOST_EN: process.env.NEXT_PUBLIC_API_HOST_EN,
		NEXT_PUBLIC_DEPLOY_CDN: process.env.NEXT_PUBLIC_DEPLOY_CDN,
		NEXT_PUBLIC_DEPLOY_HOST: process.env.NEXT_PUBLIC_DEPLOY_HOST,
		NEXT_PUBLIC_DEPLOY_SUFFIX: process.env.NEXT_PUBLIC_DEPLOY_SUFFIX,
		NEXT_PUBLIC_DEPLOY_VERSION: process.env.NEXT_PUBLIC_DEPLOY_VERSION,
		NEXT_PUBLIC_DEPLOY_APP_NAME: process.env.NEXT_PUBLIC_DEPLOY_APP_NAME,
		NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
		NEXT_PUBLIC_SENTRY_ENABLED: process.env.NEXT_PUBLIC_SENTRY_ENABLED,
	},
})
